export default __webpack_public_path__ + "static/ai-marketing-3-c1c95f74b3a9ebd06388de6588386b8e.png";